/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrSymptomTypename = "PhrSymptom" as const;

/**
 *
 * @export
 * @interface PhrSymptom
 */
export interface PhrSymptom {
  /**
   *
   * @type {string}
   * @memberof PhrSymptom
   */
  hasSymptom?: string;
  /**
   *
   * @type {string}
   * @memberof PhrSymptom
   */
  impression?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrSymptom
   */
  readonly __typename?: string;
}

export function PhrSymptomFromJSON(json: any): PhrSymptom {
  return PhrSymptomFromJSONTyped(json, false);
}

export function PhrSymptomFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrSymptom {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrSymptomTypename,

    hasSymptom: !exists(json, "has_symptom") ? undefined : json["has_symptom"],
    impression: !exists(json, "impression") ? undefined : json["impression"],
  };
}

export function PhrSymptomToJSON(object?: PhrSymptom | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    has_symptom: value.hasSymptom,
    impression: value.impression,
  };
}
